/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { Random } from "random-js";
import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import firebase from 'firebase';
import ls from "@/common/localStorage"

var cn = ls.getSessionEventCollectionName();
const eventRef = (cn ? con.eventDB.collection(cn).doc('EventInfo') : null);
const storageRef = con.storageRef
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var getAllFloorMapsAPI = con.getAllFloorMapsAPI;
var getFloorMapDetailAPI = con.getFloorMapDetailAPI;
var saveFloorMapAPI = con.saveFloorMapAPI;

export default {
    fetchVenues({ commit }) {
        return new Promise((resolve, reject) => {      
            eventRef.get().then((doc)=>{
                let Venueinfo = [];
                if(doc.data().Venueinfo){
                    Venueinfo = doc.data().Venueinfo;
                }
                commit('SET_VENUES', Venueinfo)
                resolve(Venueinfo);
            }).catch(err=>{ reject(err) })          
        })    
    },
    fetchVenue(context, id) {
        return new Promise(async(resolve, reject) => {
            let Coordinates = {lat:0, lng:0};
            if (id === null) {
               await context.dispatch("getDeviceLocation").then(position=>{
                   Coordinates.lat = position.coords.latitude;
                   Coordinates.lng = position.coords.longitude;
               }).catch(err=> console.log(err))

                resolve({
                    status: 200,
                    data: {
                        City: null,
                        CountryName: null,
                        EventID: Session_Event_Id,
                        Name: null,
                        Address: null,
                        Latitude: Coordinates.lat,
                        Longitude: Coordinates.lng,
                        FloormapID: null,
                        ID: null,
                        IsCentigrade: true,
                        IsPrimary: false,
                        PinColor: null,
                        TooltipStateIsOpen: false,
                        ZipCode: null,
                        IsPublished: true
                    }
                })
            } else {
                eventRef.get().then((doc)=>{
                    let Venues = [];
                    if(doc.data().Venueinfo){
                        Venues = doc.data().Venueinfo.filter(item=> item.ID == id);
                    }
                    resolve({status:200, data:Venues[0]});
                }).catch(err=>{ reject(err) })
            }
        })
    },    
    updateVenue(context, field) {
        return new Promise((resolve, reject) => { 
            eventRef.get().then((doc)=>{
                if(doc.data().Venueinfo){
                    let Venueinfo = doc.data().Venueinfo;  
                    let foundIndex = Venueinfo.findIndex(item=> item.ID == field.id);      
                    Venueinfo[foundIndex] = field.data;     
                    eventRef.update({Venueinfo: Venueinfo}).then(()=>{
                        resolve({status: 200, message: "Data Updated Successfully." }) ;
                    }).catch(err=>{ reject(err) })
                }
            }).catch(err=>{ reject(err) })           
        })
    },
    addVenue(context, field) {   
        return new Promise((resolve, reject) => { 
            let Venueinfo = [];
            eventRef.get().then(async (doc)=>{
                if(doc.data().Venueinfo){
                    Venueinfo = doc.data().Venueinfo;                    
                }
                let id = await context.dispatch('generateNumber');
                field.data.ID = `L${id}`;
                Venueinfo.push(field.data);
                eventRef.update({Venueinfo: Venueinfo}).then(()=>{
                    resolve({status: 200, message: "Data Added Successfully.", id: id }) ;
                }).catch(err=>{ reject(err) })
            }).catch(err=>{ reject(err) })           
        })
    },
    changeStatus(context, field) {
        return new Promise((resolve, reject) => { 
            eventRef.get().then((doc)=>{
                if(doc.data().Venueinfo){
                    let Venueinfo = doc.data().Venueinfo;  
                    let foundIndex = Venueinfo.findIndex(item=> item.ID == field.id);       
                    Venueinfo[foundIndex].IsPublished = field.IsPublished;     
                    eventRef.update({Venueinfo: Venueinfo}).then(()=>{
                        resolve({status: 200, message: "Data Updated Successfully." }) ;
                    }).catch(err=>{ reject(err) })
                }
            }).catch(err=>{ reject(err) })           
        })
    },
    generateNumber(context, numberLength) {
        const random = new Random(); // uses the nativeMath engine
        //const value = random.hex(numberLength);
        const value = random.integer(100000, 999999);
        return value.toString();
    },
    getDeviceLocation(context){
        return new Promise((resolve, reject) => {
            if(navigator.geolocation){
                navigator.geolocation.getCurrentPosition(resolve, reject);
            }else{
                reject();
            }
        })
    },
    fetchAddressByCoordinates(context, field){
        return new Promise((resolve, reject) => {
            axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${field.coordinates.lat},${field.coordinates.lng}&key=${field.gmapApiKey}`).then(function (res) {
                if(res.data.error_message){
                    resolve({status: 500, data: null }) ;                    
                }else{
                    resolve({status: 200, data: res.data.results[0] }) ;             
                }
            }).catch(err=>{ reject(err) })
        })
    },
    fetchCoordinatesByAddress(context, field){
        return new Promise((resolve, reject) => {
            axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${field.Address}&key=${field.gmapApiKey}`).then(function (res) {
                if(res.data.status == "OK"){
                    resolve({status: 200, data: res.data.results[0] }) ;                                      
                }else{
                    resolve({status: 500, data: null }) ;  
                }
            }).catch(err=>{ reject(err) })
        })
    },
}